var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"pagination-wrapper",attrs:{"background":"","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total,"layout":_vm.layout},on:{"current-change":_vm.handleCurrentChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }